import { useContext } from './context'
import { useError, useFetch, useRecaptcha } from '@ztechapps/common.hook'
import { useState } from 'react'

export const useResendCode = (): [() => Promise<void>, { error: any; loading: boolean }] => {
  const { recaptchaSiteKey, url, ...context } = useContext()
  const { getTokenOrThrow } = useRecaptcha({ recaptchaSiteKey })
  const finalUrl = `${url}/resend`
  const [fetchNow, { error }] = useFetch(finalUrl)
  const [loading, setLoading] = useState(false)
  const { onError } = useError(error)

  const [, setShowCodeInput] = context.showCodeInput
  const [, setRequestId] = context.requestId
  const [, setErrorMessage] = context.errorMessage

  const onResendCode = async () => {
    try {
      setLoading(true)
      setErrorMessage(null)
      const token = await getTokenOrThrow()

      const { requestId, error } = await fetchNow({
        destination: context.destination[0],
        requestId: context.requestId[0],
        recaptchaToken: token,
      })

      if (error) {
        throw error
      }

      setRequestId(requestId)
      setShowCodeInput(true)
    } catch (e) {
      setErrorMessage(onError(e))
    } finally {
      setLoading(false)
    }
  }

  return [onResendCode, { error, loading }]
}
